import { useMemo } from 'react';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const useContactCustomFields = () => {
    const { customFields } = useCurrentAccount();

    const contactCustomFields = useMemo(() => {
        return customFields?.contact || [];
    }, [customFields]);

    return contactCustomFields;
};

export { useContactCustomFields };
